import cn from 'classnames';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import ReportsApi from '../../../API/shipment/reports-api';
import { NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button, CheckButton } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { Input, Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader, TablePagination } from '../../../components/Basic/Table';
import { H1, Text, TextGrey } from '../../../components/Basic/WrapsStyle';
import { MAP_SKLAD_RUS_ALL, SKLAD_LIST_ALL, TYPE_BUTTONS } from '../../../constans';
import { numberWithSpaces } from '../../../utils';
import ReportLine from '../MarketReports/MarketReport/ReportLine';
import styles from './styles.module.scss';

const MARKETS = {
  ozon: ['OZON-1', 'OZON-2', 'OZON-3', 'OZON-4', 'OZON-5', 'OZON-6', 'OZON-7'],
  yandex: ['B-WHITE FBS', 'U-RURU FBS'],
  wb: ['WB-1', 'WB-2', 'WB-3', 'WB-4', 'WB-5', 'WB-6', 'WB-7'],
  megamarket: ['SBER-1', 'SB ER-2'],
};

const SHOPS = {
  ozon: ['ozon1', 'ozon2', 'ozon3', 'ozon4', 'ozon5', 'ozon6', 'ozon7'],
  yandex: ['yandex1', 'yandex3', 'yandex4', 'yandex5', 'yandex6', 'yandex7', 'yandex8'],
  wb: ['wb1', 'wb2', 'wb3', 'wb4', 'wb5', 'wb6', 'wb7'],
  megamarket: ['megamarket1', 'megamarket2'],
  avito: ['avito1']
};

export const MARKETS_LIST = ['Не выбрана', 'Ozon', 'Wb', 'Yandex', 'Megamarket', 'Avito'];

const MODES = ['Режим отгрузки', 'Режим докупов', 'Честный знак'];
const MODES_OWNER = ['Режим отгрузки', 'Режим докупов', 'Честный знак', 'Финансы'];

export const WIDTH_POSTING = [
  '150px', // 0
  '400px', // 1
  '200px', // 2
  '200px', // 3
  '180px', // 4
  '127px', // 5
  '100px', // 6
  '200px', // 7
  '100px', // 8
  '40px', // 9
  '100px', // 10
  '250px', // 11
  '170px', // 12
  '140px', // 13
];

const STATUSES = ['Не выбран', 'Нет в наличии', 'Резерв', 'Частичный резерв', 'Излишки', 'Не хватает'];

const STATUSES_ALL = [
  'Не выбран',
  'Ожидает отгрузки',
  'Доставляется',
  'Прибыл на ПВЗ',
  'Продано',
  'Не принят на CЦ',
  'Арбитраж',
  'Отменено',
  'Отменено клиентом',
  'Обнаружен брак',
];

const STATUSES_ORDERS_WB = [
  'Не выбран',
  'Ожидает отгрузки',
  'Доставляется',
  'Прибыл на ПВЗ',
  'Продано',
  'Отменено',
  'Отменено клиентом',
  'Обнаружен брак',
];
const STATUSES_ORDERS_OZON = [
  'Не выбран',
  'Ожидает отгрузки',
  'Доставляется',
  'Продано',
  'Не принят на CЦ',
  'Арбитраж',
  'Отменено',
];

const STATUSES_ORDERS_SBER = [
  'Не выбран',
  'Ожидает отгрузки',
  'Доставляется',
  'Продано',
  'Отменено',
  'Отменено клиентом',
];

const MAP_STATUS = {
  Продажа: 'sold',
  Возврат: 'returned',
  'Не выбран': undefined,
};

const MAP_STATUS_REPORT_1C = {
  'Не выбран': undefined,
  Проведено: 'confirmed',
  'Не проведено': 'not_confirmed',
  'Дубль операции': 'double',
};
const STATUSES_ORDERS_YANDEX = ['Не выбран', 'Ожидает отгрузки', 'Доставляется', 'Продано', 'Отменено'];

const STATUSES_ORDERS = {
  ozon: STATUSES_ORDERS_OZON,
  yandex: STATUSES_ORDERS_YANDEX,
  wb: STATUSES_ORDERS_WB,
  megamarket: STATUSES_ORDERS_SBER,
  ALL: STATUSES_ALL,
};
const STATUSES_SHIPMENT = ['Не выбран', 'Разложен (не упакован)', 'Упакован', 'Не отсортированы', 'Отсортированы'];

const FILTER = {
  0: 'all',
  1: 'sold',
  2: 'returned',
};

const CHZN = {
  'Не выбран': null,
  Да: true,
  Нет: false,
};

function MarketReportItemsAllPage({ isExpress = false }) {
  const { id } = useParams();

  const user = useSelector((store) => store.user);
  const dispatch = useDispatch();
  const [shipment, setShipment] = useState({ market: '', shop: '', date_realization: '' });
  const [shipments, setShipments] = useState([]);

  const [load, setLoad] = useState(false);
  const [calc, setCalc] = useState({ sold: 0, return: 0, diff: 0 });

  const [checkAll, setCheckAll] = useState(false);
  const [pdfFilePath, setPdfFilePath] = useState('');

  const [packagingMode, changePackagingMode] = useState(false);

  const shipmentMode = useSelector((store) => store.ui.shipment_mode) || 'Режим отгрузки';

  const [cancelOzonOrders, changeCancelOzonOrders] = useState({ state: false, orders: [] });

  const [shippingSberOrders, changeShippingSberOrders] = useState({ state: false, orders: [] });

  const [postingsPrint, setPostingsPrint] = useState({});
  const [openChzn, setOpenChzn] = useState({ product: null, posting: null, open: false });

  const [isMany, setIsMany] = useState(isExpress);

  const [marketMany, setMarketMany] = useState(MARKETS_LIST[0]);
  const [shopName, setShopName] = useState('Все');
  const [shop, setShop] = useState('');

  const [skladName, setSkladName] = useState('Не выбран');
  const [saleSchema, setSaleSchema] = useState('Не выбрана');

  const useFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      // eslint-disable-next-line no-unused-expressions
      htmlElRef.current && htmlElRef.current.focus();
      // eslint-disable-next-line no-unused-expressions
      htmlElRef.current && htmlElRef.current.select();
    };

    return [htmlElRef, setFocus];
  };

  const [inputRef, setInputFocus] = useFocus();

  const [market, setMarket] = useState(Object.keys(MARKETS)[0]);
  const [dateFinance, setDateFinance] = useState(new Date());
  const [count, setCount] = useState([]);
  const [page, setPage] = useState(1);

  const [show, setShow] = useState(20);
  const [search, setSearch] = useState('');

  const [rates, setRates] = useState({});
  const [countStock, setCountStock] = useState([0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [provider, changeProvider] = useState({ name: 'Не выбран', id: null });

  const allProviders = useSelector((store) => store.providers);
  const [providers, setProviders] = useState([]);
  const [chzn, setChzn] = useState('Не выбран');

  const [status, changeStatus] = useState(STATUSES[0]);
  const [statusShipment, changeStatusShipment] = useState(STATUSES_SHIPMENT[0]);

  const [orderStatus, changeOrderStatus] = useState('Не выбран');
  const [operationStatus, changeOperationStatus] = useState('Не выбран');

  const [confrimedByReportsMap, setConfrimedByReportsMap] = useState({});
  const [providerMap, setProviderMap] = useState({});
  const [reports, setReports] = useState({ ids: [], byIds: {}, map: {} });

  const onChangePage = (v) => {
    setPage(v);
  };

  const onChangeTab = (n) => {
    setTab(n);
  };

  useEffect(() => {
    setMarket(Object.keys(MARKETS)[0]);
  }, []);

  const params = useMemo(() => {
    const s = status === STATUSES[0] ? '' : status;
    const shop_name = shopName === 'Все' ? '' : shopName;

    return {
      reportIds: undefined,
      shipmentFilter: isExpress
        ? {
          isExpress,
          shipmentState: 'started',
        }
        : undefined,
      limit: parseInt(show),
      page,
      search: search.trim(),
      providerId: provider.id,
      tab: FILTER[tab],
      market: marketMany === 'Не выбрана' ? undefined : marketMany.toLowerCase(),
      shop: shop_name,
      filters: {
        status_1c: MAP_STATUS_REPORT_1C[operationStatus],
        saleSchema: saleSchema === 'Не выбрана' ? undefined : saleSchema,
        skladName: MAP_SKLAD_RUS_ALL[skladName],
      },
    };
  }, [
    id,
    show,
    page,
    search,
    tab,
    provider.id,
    status,
    shopName,
    orderStatus,
    statusShipment,
    marketMany,
    chzn,
    operationStatus,
    saleSchema,
    skladName,
  ]);

  const loadData = () => {
    ReportsApi.getReportItems({ data: params })
      .then((res) => {
        const {
          data,
          reportItems,
          cardsMap = {},
          providersMap = {},
          count,
          all_count,
          finances,
          confrimedByReportsMap,
        } = res;
        const byIds = {};
        setCountStock([all_count.all, all_count.sold, all_count.returned]);

        const ids = reportItems.map((item) => item._id);
        reportItems.forEach((item) => (byIds[item._id] = item));

        // dispatch(addShipmentPostings({ byIds, ids, map: cardsMap }));

        setReports({ byIds, ids, map: cardsMap });
        setProviderMap(providersMap);
        setConfrimedByReportsMap(confrimedByReportsMap);
        setPostingsPrint({});
        setCalc(finances);

        if (res.reports.length === 1 && !isExpress) {
          setShipment(res.reports[0]);
        } else {
          setShipments(res.reports);
        }

        setCount(count);
        setLoad(true);
        setShop(res.reports[0].shop);
      })
      .catch((err) => {
        console.log(err);
        if (err.code === 140) {
          setError('Не удалось отгрузку');
        }
      });
  };

  useEffect(() => {
    console.log(params);
    loadData();
  }, [params]);

  useEffect(() => {
    const p = allProviders.filter((item) => !item.hide);
    if (p.length > 0) {
      setProviders([{ name: 'Не выбран', id: null }, ...p]);
      changeProvider({ name: 'Не выбран', id: null });
    } else {
      changeProvider({ name: '' });
    }
  }, [allProviders]);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  const clickCheckAll = (flag) => {
    if (flag) {
      const map_print = {};

      setPostingsPrint(map_print);
      setCheckAll(true);
    } else {
      setCheckAll(false);

      setPostingsPrint({});
    }
  };

  const modes = isOwner ? MODES_OWNER : MODES;

  useEffect(() => {
    setShopName('Все');
  }, [marketMany]);

  return (
    <>
      <Content>
        <H1 style={{ marginBottom: '-3px', marginBottom: '20px' }}>Все операции</H1>

        <WhiteBlock className={styles.search_block}>
          <Row className={styles.navigate_table}>
            <NavTabs
              open_tab={tab}
              tabs={['Все операции', 'Продажи', 'Возвраты']}
              isNum={true}
              num={countStock}
              style_tab={styles.style_tab}
              onChange={onChangeTab}
            />
          </Row>

          <Row className={styles.row_input}>
            {Object.keys(postingsPrint).length > 0 ? (
              <Row className={styles.row_select}>
                <Row>
                  <Button type={TYPE_BUTTONS.WHITE} style={{ marginRight: '15px' }} onClick={() => printAll()}>
                    Распечатать этикетки
                  </Button>

                  <Button
                    type={TYPE_BUTTONS.RED}
                    style={{ marginRight: '15px' }}
                    onClick={() => {
                      setCheckAll(false);
                      setPostingsPrint({});
                      setTimeout(setInputFocus, 1000);
                    }}
                  >
                    Очистить выбор
                  </Button>
                </Row>
              </Row>
            ) : (
              <Input
                value={search}
                ref={inputRef}
                onBlur={(v) => setSearch(v)}
                onClickEnter={(v) => setSearch(v)}
                label="Поиск"
              />
            )}
          </Row>

          <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>

          <Row spaceBetween={true}>
            <Row style={{ height: '40px' }}>
              <div>
                <Select
                  label="Показать на странице"
                  select={show}
                  list={['20', '50', '100', '150', '200', '500', '1000']}
                  onSelect={(v) => setShow(v)}
                  width="150px"
                  style={{ marginRight: '15px' }}
                />
              </div>

              <>
                <Select
                  list={MARKETS_LIST}
                  select={marketMany}
                  label="Площадка"
                  onSelect={(v) => setMarketMany(v)}
                  width={'150px'}
                  style={{ marginRight: '15px' }}
                />
                <Select
                  list={SHOPS[marketMany.toLowerCase()] || []}
                  select={shopName}
                  disabled={marketMany === MARKETS_LIST[0]}
                  label="Магазин"
                  onSelect={(v) => setShopName(v)}
                  width={'150px'}
                  style={{ marginRight: '15px' }}
                />
              </>

              <Select
                label="Поставщик"
                select={provider}
                valueFn={(p) => p.name}
                list={providers}
                width="200px"
                onSelect={(v) => changeProvider(v)}
                style={{ marginRight: '15px' }}
              />
              <Select
                label="Статус операции"
                select={operationStatus}
                list={['Не выбран', 'Проведено', 'Не проведено', 'Дубль операции']}
                width="200px"
                onSelect={(v) => changeOperationStatus(v)}
                style={{ marginRight: '15px' }}
              />
              <Select
                label="Склад отгрузки"
                select={skladName}
                list={SKLAD_LIST_ALL}
                width="200px"
                onSelect={(v) => setSkladName(v)}
                style={{ marginRight: '15px' }}
              />
              <Select
                label="Схема отгрузки"
                select={saleSchema}
                list={['Не выбрана', 'fbs', 'fbo', 'express']}
                width="200px"
                onSelect={(v) => setSaleSchema(v)}
                style={{ marginRight: '15px' }}
              />
            </Row>
          </Row>
        </WhiteBlock>

        <Table styles={styles.table}>
          {(user.role === 'owner' || user.role === 'admin') && (
            <TableHeader whiteHeader>
              <Row className={styles.block_calc}>
                <TextGrey className={styles.text_grey}>Итого реализовано (за вычетом возвратов): </TextGrey>
                <Text className={cn(styles.profit, calc.diff > 0 ? styles.green : styles.red)}>
                  {calc.diff > 0 && '+ '}
                  {numberWithSpaces(Math.ceil(calc.diff))}
                </Text>
              </Row>
              <Row className={styles.block_calc} style={{ marginLeft: '40px' }}>
                <TextGrey className={styles.text_grey}>Реализовано на сумму, руб.: </TextGrey>
                <Text className={cn(styles.profit, calc.sale >= 0 ? styles.green_dark : styles.red)}>
                  {calc.sale >= 0 ? '+ ' : '- '}
                  {numberWithSpaces(Math.ceil(calc.sale))}
                </Text>
              </Row>
              <Row className={styles.block_calc}>
                <TextGrey className={styles.text_grey}>Итого возвращено, руб.: </TextGrey>
                <Text className={cn(styles.profit)}>
                  {'- '}
                  {numberWithSpaces(Math.ceil(calc.returned))}
                </Text>
              </Row>
            </TableHeader>
          )}
          <TableHeader whiteHeader>
            {shipmentMode === modes[0] && (
              <>
                <HeaderTitle width={WIDTH_POSTING[9]}>
                  <CheckButton checked={checkAll} onSelect={(v) => clickCheckAll(v)} />
                </HeaderTitle>
              </>
            )}
            <HeaderTitle width={WIDTH_POSTING[0]}>Номер заказа</HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[1]} centerText={true}>
              Позиции в заказе
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[1]} centerText={true}>
              Наименование товара
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
              Артикул 1c
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[6]} centerText={true}>
              Количество
            </HeaderTitle>

            <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
              Сумма реализации
            </HeaderTitle>

            <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
              Статус заказа
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
              Статус операции
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[12]} centerText={true}>
              Поставщик
            </HeaderTitle>
          </TableHeader>
          {reports.ids.map((report) => {
            let item = reports.byIds[report];
            console.log(item);

            const confrimedByReportsItem = confrimedByReportsMap[item.info_1c?.id_confirmed_by_report];
            return (
              <ReportLine
                shipmentMode={shipmentMode}
                packagingMode={packagingMode}
                MODES={modes}
                FILTER={FILTER}
                tab={tab}
                report={reports.byIds[report]}
                shipment={shipment}
                map={reports.map}
                key={reports.byIds[report]._id}
                setInputFocus={setInputFocus}
                postingsPrint={postingsPrint}
                setOpenChzn={setOpenChzn}
                isMany={isMany}
                providerMap={providerMap}
                confrimedByReportsItem={confrimedByReportsItem}
              />
            );
          })}
        </Table>

        <TablePagination num={Math.ceil(count / show) || 1} show={page} onChange={onChangePage} />
      </Content>
    </>
  );
}

export default MarketReportItemsAllPage;
